export const listLayerKind = [
    { value: 0, name: '' },
    { value: 1, name: 'Sử dụng đất' },
    { value: 2, name: 'Ranh giới' },
    { value: 3, name: 'Giao thông' },
    { value: 4, name: 'Kiến trúc cảnh quan' },
]